
import { z } from "zod";

export const PandadocDocumentTypeValues = ["CERTIFICATE_OF_COMPLETION", "CHANGE_ORDER", "HIC", "WORK_AUTHORIZATION"] as const;
export const PandadocDocumentTypeSchema = /* @__PURE__ */ z.enum(PandadocDocumentTypeValues);
export const PandadocDocumentType: (typeof PandadocDocumentTypeSchema)["enum"] = { "CERTIFICATE_OF_COMPLETION": "CERTIFICATE_OF_COMPLETION", "CHANGE_ORDER": "CHANGE_ORDER", "HIC": "HIC", "WORK_AUTHORIZATION": "WORK_AUTHORIZATION" };
export type PandadocDocumentType = (typeof PandadocDocumentTypeValues)[number];
export const PandadocDocumentTypeDisplayNames = { "CERTIFICATE_OF_COMPLETION": "Send Certificate of Completion",
"CHANGE_ORDER": "Send Change Order Agreement",
"HIC": "Send Agreement",
"WORK_AUTHORIZATION": "Send Work Authorization", } satisfies Record<PandadocDocumentType, string>;
